import { apiAxios, apiAxiosV2, apiAxiosV2_1 } from '../config/axios';
import { Earning } from '../model/Earning';
import { Transaction } from '../model/Transaction';

export const WalletService = {
  async getWalletBalance(wid) {
    const res = await apiAxiosV2.get(`/wallet/${wid}/balance`);
    return res.data;
  },
  async getTotalValue(wid) {
    const res = await apiAxiosV2.get(`/wallet/${wid}/total`);
    return res.data;
  },
  async getMinimumPayout(wid) {
    const res = await apiAxiosV2.get(`/wallet/${wid}/minimum_payout`);
    return res.data;
  },
  async getEarningHistory(page = 1, wid) {
    const res = await apiAxiosV2.get(
      `/wallet/${wid}/transactions?page=${page}`
    );

    return Earning.fromAll(res.data);
  },
  async getTransactionHistory(wid, page = 1) {
    const res = await apiAxiosV2_1.get(`/transaction/${wid}/list?page=${page}`);
    return Transaction.fromAll(res.data);
  },
  async getTransactionDetails({ tid }) {
    const res = await apiAxiosV2_1.get(
      `/transaction/get?transaction_id=${tid}`
    );

    return Transaction.from(res.data);
  },
  async getTotalINREarned() {
    const res = await apiAxios.get('/transaction/total_inr/me');
    return res.data;
  },
  async redeemWallet(data, wid) {
    const payload = {
      vpa: data.vpa,
      paytm_phone_number: data.paytm_phone_number,
      payment_gateway: data.payment_gateway,
      payment_method: data.payment_method,
    };
    const res = await apiAxiosV2.post(`/wallet/${wid}/redeem`, payload);
    return res.data;
  },
};
